// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__3-QUP","isVisible":"Footer_isVisible__1IeSs","link":"Footer_link__2_kKx","headline":"Footer_headline__20uHb"};